import Image from '../lib/imgLink';
export default {
    Image
}